export default {
  buttons: {
    save: 'Opslaan',
  },
  error_messages: {
    product_unavailable: 'Uitverkocht!',
  },
};
